import React from 'react'
import { Illustration } from '@winnin/winnin_ui.components.illustration'
import { Title } from '@winnin/winnin_ui.components.title'
import './index.scss'

const SmallGenericEmptyState = ({ title, description }) => {
  return (
    <div className="SmallGenericEmptyState">
      <Illustration name="magnifyingGlassSearch" width={155} height={119} />

      <div className="SmallGenericEmptyState-content">
        <Title tag="h5">{title}</Title>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default SmallGenericEmptyState
